import { render, staticRenderFns } from "./switch.component.vue?vue&type=template&id=3520fb6e&scoped=true&"
import script from "./switch.component.vue?vue&type=script&lang=ts&"
export * from "./switch.component.vue?vue&type=script&lang=ts&"
import style0 from "./switch.component.vue?vue&type=style&index=0&id=3520fb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520fb6e",
  null
  
)

export default component.exports